<template>
  <div>
    <DataListStateful
      title="Черновики запросов"
      resource="shipment-request-drafts"
      store="shipmentRequestDrafts"
      :columns="columns"
      row-to="shipment-request-new"
      :allow-delete="true"
      :filter-options="filter"
      :add-route="{ name: 'shipment-request-new' }"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      columns: [
        {
          title: "Автор",
          name: "author",
          dataPath: "Author.Title",
          sortable: true,
        },
        {
          title: "Дата создания",
          name: "date",
          visible: true,
          width: 65,
          sortable: true,
        },
        {
          title: "Менеджер",
          name: "employee",
          dataPath: "Employee.Title",
          sortable: true,
        },
        {
          title: "Клиент",
          name: "client",
          dataPath: "Client.Title",
          width: 100,
          sortable: true,
          maxLength: 12,
        },
        {
          title: "Страна отправления",
          name: "sendingCountry",
          dataPath: "SendingCountry.Title",
          visible: true,
          width: 100,
          sortable: true,
          maxLength: 12,
        },
        {
          title: "Продавец",
          name: "factory",
          dataPath: "Factory.Title",
          width: 100,
          sortable: true,
          maxLength: 12,
        },
      ],
      filter: {
        date: {
          title: "Дата",
          type: "date",
        },
        author: {
          title: "Автор",
          type: "reference",
          resource: "users",
        },
        employee: {
          title: "Менеджер",
          type: "reference",
          resource: "employees",
        },
        client: {
          title: "Клиент",
          type: "reference",
          resource: "clients",
        },
        sendingCountry: {
          title: "Страна отправления",
          type: "reference",
          resource: "countries",
        },
        factory: {
          title: "Продавец",
          type: "reference",
          resource: "factories",
        },
      },
    };
  },
};
</script>
